<script>
  import { slide } from 'svelte/transition';
  import Comment from './Comment/Comment.svelte';
  import { External } from '../external';
  import { onMount } from 'svelte';
  import Post from './WallPost/Post.svelte';

  export let comment, limit, onDeleteComment, resourceData;
  export let resourceDefinitions = [];

  let description = '';
  let imgRef;
  let shouldRenderDetails = false;
  let resourceDetails = null;

  const context = comment.context;
  
  onMount(() => {
    // Find the definition for this resource type
    const resourceDef = resourceDefinitions.find(def => def.id === context.resourceType);
    
    if (resourceDef) {
      shouldRenderDetails = resourceDef.hasDetails;
      
      if (shouldRenderDetails && resourceDef.getDetails && resourceData[context.resourceType]) {
        resourceDetails = resourceDef.getDetails(
          resourceData[context.resourceType], 
          context.resourceId
        );
        
        if (resourceDetails) {
          description = resourceDetails.title;
          External.Tools.setImage(
            External.$(imgRef), 
            resourceDetails.imageData, 
            '240x160', 
            resourceDetails.imageDatabase
          );
        }
      }
    }
  });
</script>

<div in:slide out:slide={{ duration: 200 }} class="f-left col20 flex flex-start justify-center mt-10">
  <div class="circle-post-comments-wrapper col16 f-left mt-0">
    {#if context.resourceType === 'wall' && !comment.parentCommentId}
      <Post post={comment} onDeletePost={onDeleteComment} onEditPost={() => {}} />
    {:else}
      <Comment {comment} {limit} {onDeleteComment} allowReplies={true} />
    {/if}
  </div>
  <div class:none={!shouldRenderDetails} class="comments-source col4">
    <div class="video-directory-item-thumb mb-10">
      <div class="video-item-thumb-wrapper">
        <div bind:this={imgRef} class="video-item-thumb"></div>
      </div>
    </div>
    <span style="word-break: break-word">{description}</span>
  </div>
</div>
